import React, { lazy, Suspense } from 'react';

// Keep unvisited dashboards, editors and checkout screens out of the public
// storefront download. Each page owns its boundary, so navigation has feedback.
export default function lazyPage(load) {
  const Page = lazy(load);
  return function DeferredPage(props) {
    return <Suspense fallback={<div role="status" className="min-h-screen flex items-center justify-center bg-white text-slate-600">Loading…</div>}>
      <Page {...props} />
    </Suspense>;
  };
}
